import { ErrorHandler } from "@angular/core";
import { environment } from "../../environments/environment";

import * as Raven from "raven-js";

export default class CBAErrorHandler implements ErrorHandler {
  env: string;
  handleError(error) {
    console.error(error);
    this.notifyRaven(error);
  }

  constructor() {
    this.env = environment["env"];
    if (this.env !== "development") {
      Raven.config(environment["Raven"])
        .install()
        .setTagsContext({
          environment: this.env
        });
    }
  }

  notifyRaven(error) {
    if (this.env !== "development") {
      if (error.message) {
        error.message = "[" + this.env + "]:" + error.message;
      }
      Raven.captureException(error, {
        environment: this.env
      });
      Raven.showReportDialog({});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/error/error.handler.ts